import React from 'react';
import './thankyou.css';

const ThankYou = () => {
  return (
    <div className="thankyou-container">
      <div className="thankyou-content">
        <h1>Thank You!</h1>
        <p>for joining the waitlist.<br />We’ll be in touch.</p>
      </div>
    </div>
  );
};

export default ThankYou;
